import { render } from "./PlanoBasic.vue?vue&type=template&id=741680d1&scoped=true"
import script from "./PlanoBasic.vue?vue&type=script&lang=js"
export * from "./PlanoBasic.vue?vue&type=script&lang=js"

import "./PlanoBasic.vue?vue&type=style&index=0&id=741680d1&scoped=true&lang=css"
import "./PlanoBasic.vue?vue&type=style&index=1&id=741680d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741680d1"]])

export default __exports__